
import React from 'react';
// import PropTypes from 'prop-types';
// import Button from 'common/components/elements/buttons/primary';
import MembershipItem from './membership-item'
import Button from 'common/components/elements/buttons/primary';

const MMSPageMembership = () => {
   return (
      <div className='flex flex-col gap-6 px-4 w-full'>
         <div className='ml-auto'>
            <Button
               text='Promo code'
               backgroundColor='transparent'
               textColor='secondary dark:text-secondary-dark '
               classNames='h-full pl-[14px] pr-[6px]'
               iconName='hero-section'
               iconPosition='left'
               fontIconColor='secondary'
               darkIconColor='secondary-dark'
               fontIconSize='extraLarge'
               textSize='small'
               padding='none'
               textClassName='group-hover:underline'
               waveActive={ false }
               onClick={ () => {
                  console.log(123123)
               } }
            />

         </div>
         <div className='flex flex-wrap gap-4'>
            <MembershipItem
               value='Bimonthly membership'
               onClickJoin={ () => {} }
               goToJoin={ () => {} }
               availableForContentName='availableForContentName'
               price='10'
               accessType=''
               isAvalable={ true }
               isPromo={ true }
               promotion='Promo name'
               screenWidth={ 1025 }
               discountedTerms='15% off first payment'
            />
            <MembershipItem
               value='Bimonthly membership'
               onClickJoin={ () => {} }
               goToJoin={ () => {} }
               availableForContentName='availableForContentName'
               price='10'
               accessType=''
               isAvalable={ true }
               isPromo={ true }
               promotion='Promo name'
               screenWidth={ 1025 }
               discountedTerms='15% off first payment'
            />
            <MembershipItem
               value='Bimonthly membership'
               onClickJoin={ () => {} }
               goToJoin={ () => {} }
               availableForContentName='availableForContentName'
               price='10'
               accessType=''
               isAvalable={ true }
               isPromo={ true }
               promotion='Promo name'
               screenWidth={ 1025 }
               discountedTerms='15% off first payment'
            />

         </div>
      </div>
   );
}
MMSPageMembership.propTypes = {

};
MMSPageMembership.defaultProps = {
}
export default MMSPageMembership;


